module.exports = __webpack_public_path__ + "media/WR Blob 6.e59a5904.mp3";